import { render, staticRenderFns } from "./shengqing_tixian.vue?vue&type=template&id=09ec7387&scoped=true"
import script from "./shengqing_tixian.vue?vue&type=script&lang=js"
export * from "./shengqing_tixian.vue?vue&type=script&lang=js"
import style0 from "./shengqing_tixian.vue?vue&type=style&index=0&id=09ec7387&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ec7387",
  null
  
)

export default component.exports